var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Object.entries(_vm.finalOrderStatuses)),function(ref){
var key = ref[0];
var _value = ref[1];
return _c('div',{staticClass:"status-box",class:{selected: _vm.isSelectable && key == (typeof _vm.value === 'string' ? _vm.value : (_vm.value.value)),
  'status-box-selectable': _vm.isSelectable},style:({background: _vm.getStatusColor(key)}),on:{"click":function($event){return _vm.onClick(key)}}},[_c('span',[_vm._v(_vm._s(_vm.getStatusLabel(key)))]),_c('span',[_vm._v(_vm._s(_value))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }